import React from 'react';

import { HashRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/auth';
import Routes from './routes/index';

import GlobalStyles from './styles/global';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './layout/layout.scss';

function App() {
    return (
        <AuthProvider>
            <HashRouter>
                <GlobalStyles />
                <Routes />
            </HashRouter>
        </AuthProvider>
    );
}

export default App;
